var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockWise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 6.25v3.39l2.935 1.694a.625.625 0 01-.625 1.082l-3.248-1.875-.014-.01a.61.61 0 01-.031-.02l-.024-.017a.577.577 0 01-.159-.182.622.622 0 01-.073-.199l-.005-.03-.003-.029a.647.647 0 01-.002-.037L9.375 10V6.25a.625.625 0 011.25 0zm7.127-2.162a.625.625 0 00-.68.135l-1.121 1.12-.648-.646a7.496 7.496 0 100 10.606.625.625 0 10-.884-.884 6.25 6.25 0 110-8.839l.648.648-1.12 1.12a.624.624 0 00.441 1.067h3.125a.625.625 0 00.625-.625V4.665a.626.626 0 00-.386-.577z",
    fill: "#33647E"
  })));
}
export default SvgClockWise;